import React, { useState,useEffect, lazy, Suspense } from "react";
import { Card, Row, Col } from "react-bootstrap";
// import TreeView from '../../Experimental/TreeView'
import ControlsMap from "../../Properties/PropertiesConfiguration";
import "./Controls-Properties-styling.css";
import ControlsCommonProperties from "../../Properties/ControlsCommonProperties";
// import TextboxProperties from "./TextBoxProperties/TextBoxProperties"
// import CheckboxProperties from "../../Properties/CheckboxProperties"
// import RadioProperties from "../../Properties/RadioProperties"
// import ComboboxProperties from "../../Properties/ComboboxProperties"
// import DatePickerProperties from "../../Properties/DatePickerProperties"
import styles from "../../LeftNavigation/DesignerControls/BasicControls.module.css";
import { useTranslation, withTranslation } from "react-i18next";
// import ButtonProperties from "./ButtonProperties/ButtonProperties";
// import TabsProperties from "./TabsProperties/TabsProperties";
// import SubformProperties from "./SubformProperties/SubformProperties";
// import SheetProperties from "./SheetProperties/SheetProperties";
// import MultiSelectProperties from "./MultiSelectProperties/MultiSelectProperties";
// import TableProperties from "./TableProperties/TableProperties";
// import ListviewProperties from "./ListviewProperties/ListviewProperties";
// import ListviewDataAdditionProperties from "./ListviewProperties/ListviewDataAdditionProperties";
// import AdvanceListviewProperties from "./AdvanceListviewProperties/AdvanceListviewProperties";
// import OverlayProperties from "./AdvanceListviewProperties/OverlayProperties";
// import TextBoxProperties from "./TextBoxProperties/TextBoxProperties";
// import CheckBoxProperties from "./CheckBoxProperties/CheckBoxProperties";
// import ComboProperties from "./ComboProperties/ComboProperties";
// import RadioProperties from "./RadioProperties/RadioProperties";
// import ToggleProperties from "./ToggleProperties/ToggleProperties";
// import ParagraphProperties from "./ParagraphProperties/ParagraphProperties";
// import RichtextEditorProperties from "./RichtextEditorProperties/RichtextEditorProperties";
// import DatePickerProperties from "./DatePickerProperties/DatePickerProperties";
// import LabelProperties from "./LabelProperties/LabelProperties";
// import LinkProperties from "./LinkProperties/LinkProperties";
// import SectionProperties from "./SectionProperties/SectionProperties";
// import ControlLabel from '../../../ReusableComponents/ControlLabel/ControlLabel';
// import PicklistProperties from "./PicklistProperties/PicklistProperties";
// import IFrameProperties from "./IFrameProperties/IFrameProperties";
// import CaptchaProperties from "./CaptchaProperties/CaptchaProperties";
// import PasswordProperties from "./PasswordProperties/PasswordProperties";
// import ColumnProperties from "./ColumnProperties/ColumnProperties";
// import TextareaProperties from "./TextareaProperties/TextareaProperties";
// import {regexValidator} from '../../../Resources/globalFunctions';
// import ColorPicker1 from "../../../ReusableComponents/ColorPicker/ColorPicker"
// import TileProperties from "./TileProperties/TileProperties";
// import SliderProperties from "./SliderProperties/SliderProperties";
// import ImageProperties from "./ImageProperties/ImageProperties";
// import ImageCarouselProperties from "./ImageCarouselProperties/ImageCarouselProperties";
// import DoclistProperties from "./DoclistProperties/DoclistProperties";
// import WizardProperties from "./WizardProperties/WizardProperties";
// import SideNavigationProperties from "./SideNavigationProperties/SideNavigationProperties";
// import StepProperties from "./StepProperties/StepProperties";
// import PageProperties from "./PageProperties/PageProperties";
// import ReportProperties from './ReportProperties/ReportProperties';
// import LoginHeaderProperties from "./LoginHeaderProperties/LoginHeaderProperties";
// import MenuProperties from "./MenuProperties/MenuProperties";
import { useSelector } from "../../../Redux";

import "../ControlPropertiesCSS/ComboProperties.css";
import "../ControlPropertiesCSS/menuProperties.css";
import "../ControlPropertiesCSS/MultiSelectProperties.css";
import "../ControlPropertiesCSS/PicklistPopup.css";
import "../ControlPropertiesCSS/RadioProperties.css";
import "../ControlPropertiesCSS/SectionProperties.css";
import "../ControlPropertiesCSS/TabProperties.css";
import "../ControlPropertiesCSS/wizardProperties.css";
import { PagePropertiesNew } from "./PageProperties/PagePropertiesNew";
import { GetState, GetStateFromData } from "../../CustomHooks/CustomHooks";
import { formStateStore } from "../../../Redux/Store/store";
import { updateGridContexts } from "../../../Redux/Actions/FormStateActions";

const ButtonProperties = lazy(() =>
  import("./ButtonProperties/ButtonProperties")
);
const TabsProperties = lazy(() => import("./TabsProperties/TabsProperties"));
const SubformProperties = lazy(() =>
  import("./SubformProperties/SubformProperties")
);
const ListviewPopupProperties = lazy(() =>
 import("./ListviewProperties/ListviewPopupProperties")
);
const AdvanceListviewPopupProperties = lazy(() =>
 import("./AdvanceListviewProperties/AdvanceListviewPopupProperties")
);
const SheetProperties = lazy(() => import("./SheetProperties/SheetProperties"));
const MultiSelectProperties = lazy(() =>
  import("./MultiSelectProperties/MultiSelectProperties")
);
const TableProperties = lazy(() => import("./TableProperties/TableProperties"));
const ListviewProperties = lazy(() =>
  import("./ListviewProperties/ListviewProperties")
);
const ListviewDataAdditionProperties = lazy(() =>
  import("./ListviewProperties/ListviewDataAdditionProperties")
);
const AdvanceListviewProperties = lazy(() =>
  import("./AdvanceListviewProperties/AdvanceListviewProperties")
);
const OverlayProperties = lazy(() =>
  import("./AdvanceListviewProperties/OverlayProperties")
);
const TextboxProperties = lazy(() =>
  import("./TextBoxProperties/TextBoxProperties")
);
const CheckBoxProperties = lazy(() =>
  import("./CheckBoxProperties/CheckBoxProperties")
);
const ComboProperties = lazy(() => import("./ComboProperties/ComboProperties"));
const RadioProperties = lazy(() => import("./RadioProperties/RadioProperties"));
const ToggleProperties = lazy(() =>
  import("./ToggleProperties/ToggleProperties")
);
const ParagraphProperties = lazy(() =>
  import("./ParagraphProperties/ParagraphProperties")
);
const RichtextEditorProperties = lazy(() =>
  import("./RichtextEditorProperties/RichtextEditorProperties")
);
const DatePickerProperties = lazy(() =>
  import("./DatePickerProperties/DatePickerProperties")
);
const LabelProperties = lazy(() => import("./LabelProperties/LabelProperties"));
const LinkProperties = lazy(() => import("./LinkProperties/LinkProperties"));
const SectionProperties = lazy(() =>
  import("./SectionProperties/SectionProperties")
);
// const ControlLabel= lazy(() => import("../../../ReusableComponents/ControlLabel"));
const PicklistProperties = lazy(() =>
  import("./PicklistProperties/PicklistProperties")
);
const IFrameProperties = lazy(() =>
  import("./IFrameProperties/IFrameProperties")
);
const CaptchaProperties = lazy(() =>
  import("./CaptchaProperties/CaptchaProperties")
);
const PasswordProperties = lazy(() =>
  import("./PasswordProperties/PasswordProperties")
);
const ColumnProperties = lazy(() =>
  import("./ColumnProperties/ColumnProperties")
);
const TextareaProperties = lazy(() =>
  import("./TextareaProperties/TextareaProperties")
);
const TileProperties = lazy(() => import("./TileProperties/TileProperties"));
const SliderProperties = lazy(() =>
  import("./SliderProperties/SliderProperties")
);
const ImageProperties = lazy(() => import("./ImageProperties/ImageProperties"));
const ImageCarouselProperties = lazy(() =>
  import("./ImageCarouselProperties/ImageCarouselProperties")
);
const DoclistProperties = lazy(() =>
  import("./DoclistProperties/DoclistProperties")
);
const WizardProperties = lazy(() =>
  import("./WizardProperties/WizardProperties")
);
const SideNavigationProperties = lazy(() =>
  import("./SideNavigationProperties/SideNavigationProperties")
);
// const StepProperties = lazy(() => import("./StepProperties/StepProperties"));
const PageProperties = lazy(() => import("./PageProperties/PageProperties"));
const ReportProperties = lazy(() =>
  import("./ReportProperties/ReportProperties")
);
const LoginHeaderProperties = lazy(() =>
  import("./LoginHeaderProperties/LoginHeaderProperties")
);
const MenuProperties = lazy(() => import("./MenuProperties/MenuProperties"));

const Properties = (props) => {
  const { t } = useTranslation();
  var HTMLTag = [];
  var HTMLTag1 = [];
  var HTMLKeys = [];

  const contexts = GetStateFromData(props.containerId);
  

  // const [controlSelected, setControlSelected] = useState(false);

  // window.selectedControlId_function = (
  //   controlSelectedPassed,
  //   controlSelectedId
  // ) => {
  //   if (controlSelectedPassed?.elem_type === "CustomControl") {
  //     const newControl = {
  //       ...controlSelectedPassed,
  //       elem_type: controlSelectedPassed.controlName,
  //     };
  //     setControlSelected((prev) => newControl);
  //   } else {
  //     setControlSelected((prev) => controlSelectedPassed);
  //   }
  // };
  const {controlSelected,isButtonProperties} = GetState("controlSelected",'isButtonProperties');

  const {
    toggleProperty,
    showSubForm,
    setShowSubForm,
    openProperties,
    openCanvasForSubform,
    setOpenProperties,
    propertyPinned,
    // controlSelected
  } = contexts.contexts;

  const gridContexts = GetStateFromData(props.containerId, "data2");
  const { renderAdvanceListView }  = GetState("renderAdvanceListView");

  const { showListviewPopupProperties, showAdvListviewPopupProperties } = gridContexts.gridStates;

  const [borderStyle, setBorderStyle] = useState("solid");
  const [borderWidth, setBorderWidth] = useState(1);

  const [showDataAdditionProperties, setShowDataAdditionProperties] =
    useState(false);
  const [showListviewOverlayProperties, setShowListviewOverlayProperties] =
    useState(false);
  if (controlSelected && showDataAdditionProperties === true) {
    // setShowDataAddition(false);
  }
  // if (
  //   controlSelected &&
  //   controlSelected?.id !== props?.subformState?.id &&
  //   showSubForm === true
  // ) {
  //   setShowSubForm(false);
  // }
  if (
    controlSelected &&
    controlSelected.elem_type !== "listview" &&
    showListviewPopupProperties === true
  ) {
    formStateStore.dispatch(updateGridContexts({name: "showListviewPopupProperties", key: props.containerId, value: false}));

  }
  if (
    controlSelected &&
    controlSelected?.elem_type?.toLowerCase() !== "advancelistview" &&
    showAdvListviewPopupProperties === true
  ) {
    formStateStore.dispatch(updateGridContexts({name: "showAdvListviewPopupProperties", key: props.containerId, value: false}));
  }
  if (controlSelected) {
    var controlType = controlSelected.elem_type; //To be changed as controlSelected.elem_type
    var PropertiesLabel = Object.keys(ControlsCommonProperties);
    var controlSpecificPropertiesLabel = [];
    var controlSpecificPropertiesLabel2 = [];

    switch (controlType) {
      case "textbox":
        controlSpecificPropertiesLabel = [
          ...PropertiesLabel,
          ...Object.values(TextboxProperties),
        ];
        Object.keys(TextboxProperties).forEach((key) => {
          HTMLKeys.push(key);
        });
        break;
      case "textbox":
        controlSpecificPropertiesLabel2 = [
          ...PropertiesLabel,
          ...Object.keys(TextboxProperties),
        ];
        break;
    }

    Object.values(controlSpecificPropertiesLabel).forEach((key) => {
      var HTMLTag2 = [];
      Object.keys(key).forEach((item) => {
        // HTMLTag2.push(appendHTMLTag(item.trim()));
        // HTMLTag.push(appendHTMLTag(item.trim()));
      });
      HTMLTag1.push(HTMLTag2);
    });
  }

  function saveProperties(action, property, value, parent) {
    if (action === "cancel") {
      props.hideProperties();
      return;
    } else if (action === "save") {
      var obj = props.formData;
      var IDMatched = false;
      for (var key in obj) {
        if (
          key === "id" &&
          obj[key] === "FormDef" &&
          controlSelected.id === "FormDef"
        ) {
          var temp_pageStyle = {};

          if (parent === "page") {
            if (obj.pageStyle) {
              for (key in obj.pageStyle) {
                temp_pageStyle[key] = obj.pageStyle[key];
              }
            } else {
              obj["pageStyle"] = {};
            }
            if (property === "backgroundColor") {
              delete temp_pageStyle["backgroundImage"];
              delete temp_pageStyle["backgroundRepeat"];
              delete temp_pageStyle["backgroundPosition"];
              delete temp_pageStyle["background-size"];
              delete temp_pageStyle["background-position-x"];
              delete temp_pageStyle["background-position-y"];
            }
            if (property === "backgroundImage") {
              delete temp_pageStyle["background-size"];
              delete temp_pageStyle["backgroundColor"];
              delete temp_pageStyle["background-position-x"];
              delete temp_pageStyle["background-position-y"];
            }
            if (property === "backgroundPosition") {
              delete temp_pageStyle["background-position-x"];
              delete temp_pageStyle["background-position-y"];
            }
            temp_pageStyle[String(property)] = value;
            obj.pageStyle = temp_pageStyle;
            props.applyChanges(obj);
          } else {
            if (obj.style) {
              for (key in obj.style) {
                temp_pageStyle[key] = obj.style[key];
              }
            } else {
              obj["style"] = {};
            }
            if (property === "left" || property === "right") {
              delete temp_pageStyle["margin"];
            }

            if (property === "left") {
              delete temp_pageStyle["right"];
            }
            if (property === "right") {
              delete temp_pageStyle["left"];
            }
            if (property === "top") {
              delete temp_pageStyle["bottom"];
            }
            if (property === "bottom") {
              delete temp_pageStyle["top"];
            }
            if (property === "align-self") {
              delete temp_pageStyle["top"];
              delete temp_pageStyle["bottom"];
            }
            if (property === "margin") {
              temp_pageStyle["left"] = "0 !important";
              temp_pageStyle["right"] = "0 !important";
            }
            temp_pageStyle[String(property)] = value;
            obj.style = temp_pageStyle;
            //  //////console.log.log(temp_pageStyle);
            props.applyChanges(obj);
          }
        }
        if (key === "children") {
          var children = obj.children;
          for (var i = 0; i < children.length; i++) {
            if (Object.keys(children[i]).includes("children")) {
              for (var j = 0; j < children[i].children.length; j++) {
                var temp_children = children[i].children[j];
                if (Object.keys(temp_children).includes("children")) {
                  var temp_children2 = temp_children.children;
                  for (var k = 0; k < temp_children2.length; k++) {
                    if (Object.keys(temp_children2[k]).includes("children")) {
                      var temp_children3 = temp_children2[k].children;
                      for (var l = 0; l < temp_children3.length; l++) {
                        if (
                          Object.keys(temp_children3[l]).includes("children")
                        ) {
                          var temp_children4 = temp_children3[l].children;
                          for (var m = 0; m < temp_children4.length; m++) {
                            if (temp_children4[m].id === controlSelected.id) {
                              props.changeUndoList();
                              temp_children4[m].style = controlSelected.style;
                              //    props.hideProperties();
                              //////console.log.log(controlSelected.style);
                              //////console.log.log(temp_children4[m].style);

                              //////console.log.log(property + " " + value);

                              // Object.keys(temp_children4[m].style).map(KeyValue=>{
                              //     //////console.log.log(KeyValue + "  " + temp_children4[m].style[KeyValue])
                              // })
                              props.applyChanges(obj);

                              //////console.log.log(obj);
                              IDMatched = true;

                              break;
                            }
                          }
                          if (IDMatched === true) break;
                        }
                      }
                      if (IDMatched === true) break;
                    }
                  }
                  if (IDMatched === true) break;
                }
              }
            }
            if (IDMatched === true) break;
          }
        }
        if (IDMatched === true) break;
      }
    }
  }
 

  //  useEffect(()=>{
  //   document.getElementById("propertiesId")?.focus();
  //  },[])

  function handleEscapeKey(e) {
    if (e.code === "Escape" && openProperties === true && !propertyPinned) {
      setOpenProperties(false);
    }
  }

  return (
    <div
      tabIndex="0"
      id="propertiesId"
      onKeyDown={(e) => handleEscapeKey(e)}
      className="properties_container_main"
      style={{ border: "1px solid transparent", height: "100%" }}
      properyOf={controlSelected?.elem_type}
      dir={
        window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
          ? "rtl"
          : "ltr"
      }
    >
      <Suspense fallback={<div> {t("Loading ....")}</div>}>
        {controlSelected !== undefined || controlSelected !== null ? (
          <>
            {controlSelected?.elem_type &&
            controlSelected.elem_type !== null &&
            controlSelected.elem_type !== "" ? (
              // <Card dir={window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ? "rtl":"ltr"} className={styles.propertiesWrapperDiv}>
              <Card className={styles.propertiesWrapperDiv}>
                {controlSelected &&
                  (controlSelected.elem_type === "Design Page" ||
                    controlSelected.elem_type === "form") && (
                    <PagePropertiesNew
                      containerId={props.containerId}
                      formData={props.formData}
                      selectedControl={controlSelected}
                      setFormState2={props.setFormState2}
                      microFrontendData={props.microFrontendData}
                      applyChanges={props.applyChanges}
                      themeJSONData={props.themeJSONData}
                    />
                  )}
                {controlSelected &&
                  controlSelected.elem_type === "LoginHeader" && (
                    <LoginHeaderProperties
                      containerId={props.containerId}
                      formData={props.formData}
                      selectedControl={controlSelected}
                      setFormState2={props.setFormState2}
                      applyChanges={props.applyChanges}
                      themeJSONData={props.themeJSONData}
                    />
                  )}
                {controlSelected && controlSelected.elem_type === "report" && (
                  <ReportProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}

                {controlSelected.elem_type === "textbox" &&
                controlSelected.style &&
                controlSelected.style.isPassword == true ? (
                  <PasswordProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                ) : (
                  controlSelected.elem_type === "textbox" && (
                    <TextboxProperties
                      containerId={props.containerId}
                      formData={props.formData}
                      selectedControl={controlSelected}
                      setFormState2={props.setFormState2}
                      applyChanges={props.applyChanges}
                      themeJSONData={props.themeJSONData}
                    />
                  )
                )}

                {controlSelected.elem_type === "tab" && (
                  <TabsProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}

                {controlSelected.elem_type === "combo" && (
                  <ComboProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}
                {(controlSelected.elem_type === "frame" ||
                  controlSelected.elem_type === "section" ||
                  controlSelected.elem_type === "headerframe") && (
                  <SectionProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}

                {controlSelected.elem_type === "listbox" && (
                  <MultiSelectProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}
                {controlSelected.elem_type === "radio" && (
                  <RadioProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}

                {controlSelected.elem_type === "picklist" && (
                  <PicklistProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}

                {controlSelected.elem_type === "sheet" && (
                  <SheetProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}
                {controlSelected.elem_type === "datepick" && (
                  <DatePickerProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}

                {controlSelected.elem_type === "iframe" && (
                  <IFrameProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}

                {controlSelected.elem_type === "captcha" && (
                  <CaptchaProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}

                {controlSelected.elem_type === "label" && (
                  <LabelProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}

                {controlSelected.elem_type === "link" && (
                  <LinkProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}

                {controlSelected.elem_type === "doclist" && (
                  <DoclistProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}

                {controlSelected.elem_type === "column" && (
                  <ColumnProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}

                {controlSelected &&
                controlSelected.elem_type.toLowerCase() === "textarea" &&
                controlSelected.style &&
                controlSelected.style["isRichTextEditor"] === "true" ? (
                  <RichtextEditorProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={(obj, arg) => props.applyChanges(obj, arg)}
                  />
                ) : controlSelected &&
                  controlSelected.elem_type.toLowerCase() === "textarea" ? (
                  <TextareaProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                ) : null}
                {controlSelected.elem_type === "image" && (
                  <ImageProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}

                {(controlSelected.elem_type === "wizard_h" ||
                  controlSelected.elem_type === "wizard_v" ||
                  controlSelected.elem_type === "sidenavigation" || controlSelected.elem_type === "Step" || controlSelected.elem_type === "SubStep") && (
                  <WizardProperties
                    containerId={props.containerId}
                    element={controlSelected.elem_type}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                   microFrontendData={props.microFrontendData}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}
                {controlSelected.elem_type.toLowerCase() === "menu" && (
                  <MenuProperties
                    containerId={props.containerId}
                    element={controlSelected.elem_type}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}
                {/* {(controlSelected.elem_type === "Step" || controlSelected.elem_type === "SubStep") && (
                  <StepProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    microFrontendData={props.microFrontendData}
                    themeJSONData={props.themeJSONData}
                  />
                )} */}

                {/* {controlSelected.elem_type === "datepick" &&
                    <SheetProperties formData={props.formData} selectedControl={controlSelected} setFormState2={props.setFormState2} applyChanges={props.applyChanges} themeJSONData={props.themeJSONData} />
                } */}

                {controlSelected.controlName === "slider" && (
                  <SliderProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}

                {controlSelected.elem_type === "checkbox" && (
                  <CheckBoxProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}
                {controlSelected.elem_type === "tile" && (
                  <TileProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={props.applyChanges}
                    themeJSONData={props.themeJSONData}
                  />
                )}
                {controlSelected &&
                !isButtonProperties &&
                controlSelected.elem_type.toLowerCase() === "button" ? (
                  <ButtonProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    microFrontendData={props.microFrontendData}
                    applyChanges={(obj, saveOldState) =>
                      props.applyChanges(obj, saveOldState)
                    }
                    setShowSubForm={() => setShowSubForm(true)}
                  />
                ) : null}
                {openCanvasForSubform === "subform" &&
                (controlSelected.elem_type === "button" && isButtonProperties) ? (
                  <SubformProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    subformState={props.subformState}
                    selectedControl={controlSelected}
                    applyChanges={(obj, saveOldState) =>
                      props.applyChanges(obj, saveOldState)
                    }
                    setShowSubForm={() => setShowSubForm(true)}
                  />
                ) : null}

                {(openCanvasForSubform === "advanceListviewFromScratch" &&
                controlSelected.elem_type?.toLowerCase() === "advancelistview") ||
                (openCanvasForSubform === "showDataAdditonSection" &&
                  controlSelected.elem_type === "listview") ? (
                  <AdvanceListviewPopupProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={{ popupStyle: {}, ...controlSelected }}
                    // applyChanges={(obj, saveOldState) =>
                    //   props.applyChanges(obj, saveOldState)
                    // }
                    // setShowSubForm={() => setShowSubForm(true)}
                  />
                ) : null}
                {controlSelected &&
                controlSelected.elem_type.toLowerCase() === "table" ? (
                  <TableProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={(obj) => props.applyChanges(obj)}
                  />
                ) : null}
                {(!openCanvasForSubform ||
                  openCanvasForSubform === "subform" ||
                  openCanvasForSubform === "advanceListviewFromScratch") && 
                  controlSelected &&
                showDataAdditionProperties === false &&
                showListviewPopupProperties === false &&
                controlSelected.elem_type.toLowerCase() === "listview" &&
                controlSelected.style &&
                controlSelected.style["isAdvancedListview"] === "false" ? (
                  <ListviewProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={(obj, arg) => props.applyChanges(obj, arg)}
                    showDataAddition={showDataAdditionProperties}
                    setShowDataAddition={(arg) =>
                      setShowDataAdditionProperties(arg)
                    }
                  />
                ) : null}
                {showDataAdditionProperties === true ? (
                  <ListviewDataAdditionProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={(obj) => props.applyChanges(obj)}
                  />
                ) : null}

                {/* {controlSelected && controlSelected.elem_type.toLowerCase() ==="listview" && controlSelected.style && controlSelected.style["isAdvancedListview"]==="true" && showListviewOverlayProperties === false ?
            <AdvanceListviewProperties formData={props.formData} selectedControl={controlSelected} setFormState2={props.setFormState2} applyChanges={(obj,arg)=>props.applyChanges(obj,arg)}
            setShowListviewOverlayProperties={(arg)=> setShowListviewOverlayProperties(arg)}/> :null
        } */}

                {controlSelected && !openCanvasForSubform &&
                 showAdvListviewPopupProperties === false &&
                controlSelected.elem_type.toLowerCase() === "advancelistview" &&
                controlSelected.style ? (
                  <AdvanceListviewProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={(obj, arg) => props.applyChanges(obj, arg)}
                    setShowListviewOverlayProperties={(arg) =>
                      setShowListviewOverlayProperties(arg)
                    }
                  />
                ) : null}

                {controlSelected &&
                controlSelected.elem_type.toLowerCase() === "listview" &&
                controlSelected.style &&
                controlSelected.style["isAdvancedListview"] === "true" &&
                showListviewOverlayProperties === true ? (
                  <OverlayProperties
                    containerId={props.containerId}
                    setShowListviewOverlayProperties={(arg) =>
                      setShowListviewOverlayProperties(arg)
                    }
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={(obj, arg) => props.applyChanges(obj, arg)}
                  />
                ) : null}
                {controlSelected &&
                controlSelected.elem_type.toLowerCase() === "toggle" ? (
                  <ToggleProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={(obj, arg) => props.applyChanges(obj, arg)}
                  />
                ) : null}
                {controlSelected &&
                controlSelected.elem_type.toLowerCase() === "paragraph" ? (
                  <ParagraphProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={(obj, arg) => props.applyChanges(obj, arg)}
                  />
                ) : null}
                {controlSelected &&
                controlSelected.elem_type.toLowerCase() === "imagecarousel" ? (
                  <ImageCarouselProperties
                    containerId={props.containerId}
                    formData={props.formData}
                    selectedControl={controlSelected}
                    setFormState2={props.setFormState2}
                    applyChanges={(obj, arg) => props.applyChanges(obj, arg)}
                  />
                ) : null}
              </Card>
            ) : (
              <Card className={styles.propertiesWrapperDiv}>
                <PagePropertiesNew
                  containerId={props.containerId}
                  formData={props.formData}
                  selectedControl={props.formData}
                  setFormState2={props.setFormState2}
                  applyChanges={props.applyChanges}
                  microFrontendData={props.microFrontendData}
                  themeJSONData={props.themeJSONData}
                />
              </Card>
            )}
          </>
        ) : null}
      </Suspense>
    </div>
  );
};

export default Properties;
